<template>
  <div ref="listWrap">
    <wrapper-list
      @add="paasAddPage"
      @edit="paasEidtPage"
      @delete="paasDeleteTableData"
      @detail="paasDetailPage"
      @calculate="paasCalculate"
      ref="listWrap">
      <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
        <Row>
          <FormItem label="枚举编码：" class="ivu-col-span-12">
            <Input  v-model="queryParam.query_LIKE_sysEnumCode"  @on-change="queryTableDatas" clearable style="width: auto" />
          </FormItem>
          <FormItem label="枚举名字:" class="ivu-col-span-12">
            <Input  v-model="queryParam.query_LIKE_name"  @on-change="queryTableDatas" clearable style="width: auto" />
          </FormItem>
        </Row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
  </div>
</template>

<script>
  import wrapperList from "@components/paas/wrapper-list";
  import ExpandRow from './table-expand.vue';
  import metaList from "@assets/js/list/meta-list.js";
  import CellBar from '@components/paas/cell-bar'; //列表内操作
  export default {
    name: "enum-list",
    components: { wrapperList , ExpandRow ,CellBar},
    mixins: [ metaList ],
    data(){
      return{
        serviceUrl:"/sys/enum",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          query_LIKE_sysEnumCode:'',
          query_LIKE_name:'',
          query_EQ_sysEnumGroupCode: '',
        },
        height:(document.documentElement.clientHeight -210),
        tableColumns: [
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
          {
            type: 'expand',
            width: 50,
            render: (h, params) => {
              return h(ExpandRow, {
                props: {
                  rowData: params.row
                }
              })
            }
          },
          {
            title: '枚举名字',
            key: 'name'
          },
          {
            title: '枚举编码',
            key: 'sysEnumCode'
          },
          {
            title: '操作',
            width:160,
            render: (h, params) => {
              return h(CellBar,
                {
                  props:{
                    show:'icon',
                  },
                  on: {
                    // 子组件$emit传递函数,必须是箭头函数写法
                    'edit': (url)=> {
                      this.$nextTick(()=>{
                        this.paasEditOper(params.row[this.currentIdFiledName],this.serviceUrl+"/edit?sysEnumGroupCode="+this.sysEnumGroupCode);
                      })
                    },
                    'delete':()=>{
                      this.$nextTick(()=>{
                        this.paasDeleteOper(params.row[this.currentIdFiledName]);
                      })
                    },
                    'detail':()=>{
                      this.$nextTick(()=>{
                        this.paasDetailOper(params.row[this.currentIdFiledName]);
                      })
                    }
                  }
                }
              )
            }
          },
        ],

      }
    },
    methods: {
      /**
       * 查询table之前组装groupcode值
       */
      queryTableBeforeLogic() {
        let queryParam = this.$route.query;
        let sysEnumGroupCode = queryParam.sysEnumGroupCode;
        if(sysEnumGroupCode) {
          this.queryParam.query_EQ_sysEnumGroupCode = sysEnumGroupCode;
          this.sysEnumGroupCode = sysEnumGroupCode;
        }
      },
      // 添加按钮
      paasAddPage(event, url) {
        if(!url) {
          url = this.serviceUrl+'/edit';
        }
        url += "?sysEnumGroupCode="+this.sysEnumGroupCode;
        this.$router.push({'path':this.setUrlFuncId(url)});
      },
    }

  }
</script>

<style scoped>

</style>
